var app = angular.module('leonardo');

var NameListFilter = function () {
  return function (list) {
    if (!list || list.length === 0) return '';
    var names = [];
    angular.forEach(list, function(element) {
      names.push(element.name);
    });
    return names.join(', ');
  }
};
app.filter('namelist', [NameListFilter]);